<template>
  <div class="video-page">
    <autoplay-video>
      <source :src="videoMp4" type="video/mp4" />
      <source :src="videoWebm" type="video/webm" />
    </autoplay-video>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AutoplayVideo from "../components/AutoplayVideo";

export default {
  components: { AutoplayVideo },
  computed: {
    ...mapGetters(["aftermathVideoSrc"]),
    videoMp4() {
      return this.$store.state.videoDownloadURLs[this.aftermathVideoSrc.mp4];
    },
    videoWebm() {
      return this.$store.state.videoDownloadURLs[this.aftermathVideoSrc.webm];
    },
  },
  beforeMount() {
    // check if the side has been set or if we're accidentally skipping

    if (this.$store.state.side == "") {
      // set side automatically - this isn't ideal
      this.$store.commit("SET_SIDE", "advocate");

      console.warn(
        "the side has not been set yet - setting side automatically"
      );
    }
  },
};
</script>

<style lang="less">
</style>
